import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import icArrowLeft from "@/assets/icons/ic-arrow-left.svg";
import { getPublicAgent } from "@/services/agent-list-service";
import type { PublicAgentDetail } from "@/types/agent";
import { AgentDetailContent } from "@/components/agent/agent-detail-content";
import { Button } from "@/components/ui/button";

export default function AgentDetailPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [agent, setAgent] = useState<PublicAgentDetail | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!id) return;
    setIsLoading(true);
    getPublicAgent(id)
      .then(setAgent)
      .catch((err) => {
        if (err?.response?.status === 404) {
          navigate("/404", { replace: true });
          return;
        }
        setError(true);
      })
      .finally(() => setIsLoading(false));
  }, [id, navigate]);

  if (error || (!isLoading && !agent)) return null;

  return (
    <>
      {isLoading && (
        <div className="flex items-center justify-center py-20 h-[60vh] w-full">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-black/10 border-t-[#FF3B00]" />
        </div>
      )}
      <div 
        className="flex flex-col items-center gap-6 py-6 md:py-10 max-w-[1120px] px-5 min-[1120px]:px-0 mx-auto w-full"
        style={{ display: isLoading ? "none" : "flex" }}
      >
      <div className="flex lg:flex-row flex-col lg:items-center item-start gap-4 w-full">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate(-1)}
          className="w-12 h-12 bg-white"
        >
          <img src={icArrowLeft} alt="Icon Arrow Left" />
        </Button>
        <h1 className="text-xl font-bold leading-7 tracking-[-0.02em] text-[#202020]">
          Agent detail
        </h1>
      </div>

      <div className="w-full h-px bg-black/[0.09] md:hidden" />

      {agent && <AgentDetailContent agent={agent} />}
    </div>
    </>
  );
}
